import $ from "jquery";
window.jQuery = $;
window.$ = $;

require("./shadow-scroller");
import { gsap, Back, Elastic } from "gsap";
import "./slick";
import "./accordion";
import "./accordion-menu";
import "./megaMenu";
import "./skipContent";
import "./toggleDrawer";
import "./tabbedContent";
import "./cardsCarousel";

(function ($) {
  "use strict";

  var site = (window.site = {});

  site.elements = {
    menu: $(".page-hamburger-main-menu"),
    sideMenu: $(".menu-side"),
    btnMenu: $(".btn-menu"),
    hamburgerMenu: $(".site-header__main-nav"),
    pageHead: "site-header",
  };

  site.getBreakpoint = (function () {
    var breakpoint;

    function getBreakpointContent() {
      return window
        .getComputedStyle(document.body, ":after")
        .content.toLowerCase()
        .replace(/"/g, "");
    }

    breakpoint = getBreakpointContent();
    $(window).resize(function () {
      breakpoint = getBreakpointContent();
    });

    return function () {
      return breakpoint;
    };
  })();

  /* Generate overlay */

  site.showDrawerOverlay = function () {
    $("body").addClass("toggled-drawer-offset-overlay");
  };

  site.hideDrawerOverlay = function () {
    $("body").removeClass("toggled-drawer-offset-overlay");
  };

  /* End of Generating overlay */

  /* Initializing shadow scroller */

  site.shadowScroller = function () {
    $(".item-page table").shadowScroller();
  };

  /* End of initializing shadow scroller */

  /* Reset rs form submit button when clickout outside of recaptcha */

  site.recaptcha = function () {
    $(document).mouseup(function (e) {
      var iframe = $('iframe[title="recaptcha"]');

      // if the target of the click outside of the recaptcha iframe

      if (!iframe.is(e.target) && iframe.has(e.target).length === 0) {
        $(".rsform-submit-button").each(function () {
          if ($(this).prop("disabled")) {
            $(this).removeProp("disabled");
          }
        });
      }
    });
  };

  /* End of reset rs form submit button when clickout outside of recaptcha */

  /* Initializing dropdown menu */

  site.accordionMenu = function (menu) {
    $(menu).accordionMenu({
      addIndicator: true,
      onlyOneShown: true,
      autoScroll: true,
    });
  };

  /* End of Initializing dropdown menu */

  /* Hamburger menu */

  site.hamburgerMenu = {
    isActive: false,

    close: function () {
      site.elements.hamburgerMenu.removeClass("active");
      site.elements.btnMenu.removeClass("active");
      site.elements.btnMenu.attr("aria-expanded", false);
      if ($("body.drawer-open").length) {
        site.toggleDrawer.closeDrawer(
          $("[data-drawer-toggle='top-search-module']"),
          $("body")
        );
      }
      $("body").removeClass("menu-open drawer-open");
      $("html").removeClass("menu-open");
      site.hideDrawerOverlay();
      this.isActive = false;
    },

    open: function () {
      site.elements.hamburgerMenu.addClass("active");
      site.elements.btnMenu.addClass("active");
      site.elements.btnMenu.attr("aria-expanded", true);
      if ($("body.drawer-open").length) {
        site.toggleDrawer.closeDrawer(
          $("[data-drawer-toggle='top-search-module']"),
          $("body")
        );
      }
      $("body").addClass("menu-open");
      $("html").addClass("menu-open");
      site.showDrawerOverlay();
      this.isActive = true;
    },

    init: function () {
      var that = this;
      site.elements.btnMenu.click(function (e) {
        e.preventDefault();
        that.isActive ? that.close() : that.open();
      });

      site.elements.btnMenu.keypress(function (e) {
        if (e.which == 13) {
          //Enter key pressed
          e.preventDefault();
          that.isActive ? that.close() : that.open();
        }
      });

      $(document).on("keyup", function (e) {
        if (e.which == 27) {
          if ($("." + site.elements.pageHead).length && that.isActive) {
            that.close();
          }
        }
      });

      $(document).on("click touchend", function (e) {
        if (
          !$(e.target).closest("." + site.elements.pageHead).length &&
          that.isActive &&
          !$(e.target).closest(".site-header__main-nav").length
        ) {
          that.close();
        }
      });

      $(window).on("resize", function () {
        if (site.getBreakpoint() === "desktop" && that.isActive) {
          that.close();
        }
      });
    },
  };

  /* End of hamburger menu */

  site.menuAnimation = function () {
    var tween = gsap.timeline({
      onStart: function () {
        gsap.set("#bump path", {
          scaleY: 1,
          svgOrigin: "200 0",
          transformOrigin: "50% top",
          ease: Elastic.easeOut,
        });
      },
    });

    restingPosition();

    $(".page-navigation-mega-menu").on("mousemove", function (e) {
      var x = e.pageX;
      var subMenu = $(e.target).closest(".sub-menu-wrapper");
      if (!subMenu.length) {
        tween.to("#bump path", {
          duration: 2.8,
          scaleY: 0.7,
          scaleX: 2,
          svgOrigin: "200 0",
          transformOrigin: "50% top",
          ease: Back.easeOut,
        });
        tween.to("#bump path", {
          duration: 2.8,
          scaleX: 2,
          svgOrigin: "200 0",
          transformOrigin: "50% top",
        });
        tween.to("#bump", { duration: 0.8, left: x, ease: Back.easeOut }, 0);
      }
    });

    $(".page-navigation-mega-menu").on("mouseleave", function (e) {
      restingPosition(e);
    });

    function restingPosition() {
      var x;
      var hw;

      if ($(".page-navigation-mega-menu .level1.active a").length) {
        x = $(".page-navigation-mega-menu .level1.active a").offset().left;
        hw =
          $(".page-navigation-mega-menu .level1.active a").outerWidth() * 0.5;
      } else {
        x = 0;
        hw = -100;
      }

      tween.to("#bump path", {
        duration: 1.8,
        scaleY: 1,
        svgOrigin: "200 0",
        transformOrigin: "50% top",
        ease: Elastic.easeOut,
      });
      tween.to("#bump path", {
        duration: 0.8,
        scaleX: 1,
        transformOrigin: "50% top",
      });
      tween.to("#bump", { duration: 0.8, left: x + hw, ease: Back.easeOut }, 0);
    }
  };

  site.expandSearch = {
    close: function (el) {
      $(el).closest(".site-header__search").removeClass("expanded");
      this.isActive = false;
      $("." + site.elements.pageHead).removeClass("search-expanded");
    },

    expand: function (el) {
      $(el).closest(".site-header__search").addClass("expanded");
      $("." + site.elements.pageHead).addClass("search-expanded");
      this.isActive = true;
    },

    init: function () {
      var that = this;
      let input = $(".js-search-query");

      input
        .on("focus mouseenter", function () {
          that.expand($(this));
        })
        .on("focusout mouseleave", function () {
          if (!$(this).val()) that.close($(this));
        });

      if (input.length > 0 && input.val().length > 0) {
        that.expand(input);
      }
    },
  };

  site.init = function () {
    site.shadowScroller();
    site.recaptcha();
    site.accordionMenu(site.elements.menu);
    site.accordionMenu(site.elements.sideMenu);
    site.hamburgerMenu.init();
    site.menuAnimation();
    site.expandSearch.init();
  };

  // Document ready

  $(function () {
    site.init();
  });
})($);
